export const ACTIVE_TRIPS_REQUEST = 'ACTIVE_TRIPS_REQUEST'
export const DRAFT_TRIPS_REQUEST = 'DRAFT_TRIPS_REQUEST'
export const CONFIRM_TRIPS_REQUEST = 'CONFIRM_TRIPS_REQUEST'
export const BOOKING_LIST_REQUEST = 'BOOKING_LIST_REQUEST'
export const START_REQUEST = 'START_REQUEST'
export const FINISH_REQUEST = 'FINISH_REQUEST'
export const SET_HOST_FILTER = 'SET_HOST_FILTER'
export const SET_TRAVELER_FILTER = 'SET_TRAVELER_FILTER'
export const SET_ORGANIZARIONS = 'SET_ORGANIZARIONS'
export const SET_PROJECTS = 'SET_PROJECTS'
